import { gql } from "@apollo/client";

const MAP_ATTRACTION = `
  attraction(where: {localization: {culture: $culture}}) {
    localization {
      localizationSet
    }
    forecaWeatherId
    displayText
    cover {
      paths
    }
    introduction {
      html
    }
    location {
      latitude
      longitude
    }
    category {
      contentItems {
        __typename
        ... on AttractionCategory {
          contentItemId
          displayText
          mapMarkerIcon{
            paths
          }
          icon
          parent {
            contentItems {
              __typename
              ... on AttractionCategory {
                contentItemId
                displayText
                mapMarkerIcon {
                  paths
                }
                icon
              }
            }
          }
        }
      }
    }
    city {
      contentItems {
        __typename
        ... on City {
          contentItemId
        }
      }
    }
  }
`
const MAP_EVENT = ``

export const mapAttraction = (input = { attraction: true, event: true }) => gql`
  query MapAttraction ($culture: String!) {
    ${input.attraction ? MAP_ATTRACTION : ''}
    ${input.event ? MAP_EVENT : ''}
  }
`

export const MAP_CITIES = gql`
  query CityInformation($culture: String!) {
    city(where: {localization: {culture: $culture}}) {
      contentItemId
      borderCoordinates
      forecaWeatherId
      openStreetMapId
      tourismOrder
      name
      cover {
        paths
      }
    }
  } 
`